import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { useEffect, useRef } from "react"
import mapboxgl from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

import {bbox, center} from '@turf/turf';

export const LocationProperty = ({ value, onChange }) => {
    const mapContainerRef = useRef();
    const mapRef = useRef();
    const drawRef = useRef();

    const updateCoordinates = () => {
        const data = drawRef.current.getAll();
        const coords = data.features[0]?.geometry.coordinates[0] || [];
        onChange?.(coords);
    }

    const centerCoord = value ? center({ type: 'Polygon', coordinates: [value] }).geometry.coordinates
      : [-121.94927889925046, 37.40588323908256];

    useEffect(() => {
        if (mapRef.current) return;

        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/terloon/cm9slw9pj00d101ssbvbdap25',
            center: centerCoord, //[-121.94927889925046, 37.40588323908256],
            zoom: 12,
        });

        mapRef.current.cursor = 'crosshair';

        const customStyles = [
            // ACTIVE (being drawn)
            // line stroke
            {
                "id": "gl-draw-line",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"]],
                "layout": {
                  "line-cap": "round",
                  "line-join": "round"
                },
                "paint": {
                  "line-color": "#D20C0C",
                  "line-dasharray": [0.2, 2],
                  "line-width": 2
                }
            },
            // polygon fill
            {
              "id": "gl-draw-polygon-fill",
              "type": "fill",
              "filter": ["all", ["==", "$type", "Polygon"]],
              "paint": {
                "fill-color": "#D20C0C",
                "fill-outline-color": "#D20C0C",
                "fill-opacity": 0.1
              }
            },
            // polygon mid points
            {
              'id': 'gl-draw-polygon-midpoint',
              'type': 'circle',
              'filter': ['all',
                ['==', '$type', 'Point'],
                ['==', 'meta', 'midpoint']],
              'paint': {
                'circle-radius': 3,
                'circle-color': '#fbb03b'
              }
            },
            // polygon outline stroke
            // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
            {
              "id": "gl-draw-polygon-stroke-active",
              "type": "line",
              "filter": ["all", ["==", "$type", "Polygon"]],
              "layout": {
                "line-cap": "round",
                "line-join": "round"
              },
              "paint": {
                "line-color": "#D20C0C",
                "line-dasharray": [0.2, 2],
                "line-width": 2
              }
            },
            // vertex point halos
            {
              "id": "gl-draw-polygon-and-line-vertex-halo-active",
              "type": "circle",
              "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
              "paint": {
                "circle-radius": 5,
                "circle-color": "#FFF"
              }
            },
            {
                id: 'gl-draw-polygon-and-line-vertex-active',
                type: 'circle',
                filter: ['all',
                  ['==', 'meta', 'vertex'],
                  ['==', '$type', 'Point'],
                  ['==', 'active', 'true']
                ],
                paint: {
                  'circle-radius': 5,
                  'circle-color': '#0000ff' // 🔴 selected vertex color
                }
              },
            // vertex points
            // {
            //   "id": "gl-draw-polygon-and-line-vertex-active",
            //   "type": "circle",
            //   "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
            //   "paint": {
            //     "circle-radius": 3,
            //     "circle-color": "#D20C0C",
            //   }
            // }
          ];

        drawRef.current = new MapboxDraw({
            styles: customStyles,
            displayControlsDefault: false,
            controls: {
                // point: true,
                // line_string: true,
                polygon: true,
                trash: true,
            },
            defaultMode: 'draw_polygon',
        });

        mapRef.current.addControl(drawRef.current);
        mapRef.current.on('draw.create', updateCoordinates);
        mapRef.current.on('draw.update', updateCoordinates);
        mapRef.current.on('draw.delete', updateCoordinates);

        if (value) {
            const geometry = {
              // id: 'user-polygon',
              type: 'Feature',
              geometry: {
                  type: 'Polygon',
                  coordinates: [value],
              },
            };
            drawRef.current.add(geometry);
            //   {
            //     type: 'Feature',
            //     geometry: {
            //         type: 'Polygon',
            //         coordinates: [value],
            //     },
            // });
            const bounds = bbox(geometry);
            mapRef.current.fitBounds(bounds);
        }

    }, []);

    return (
        <div className="location-property" ref={mapContainerRef} style={{ height: '500px', width: '100%', display: 'block' }} />
    )
}